import { render, staticRenderFns } from "./logo2.vue?vue&type=template&id=d028cbc6"
import script from "./logo2.vue?vue&type=script&lang=js"
export * from "./logo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports